const disallowedFilenameCharsRegex = /[\\/:*?"<>|]/;
const controlCharsRegex = /[\u0000-\u001F\u007F]/;
const onlyDotsRegex = /^\.+$/;

export function isValidS3Filename(filename: string) {
  if (!filename) return false;
  if (filename !== filename.trim()) return false;
  if (disallowedFilenameCharsRegex.test(filename)) return false;
  if (controlCharsRegex.test(filename)) return false;
  if (onlyDotsRegex.test(filename)) return false;

  return true;
}
